module.exports = __webpack_public_path__ + "static/media/checked.d25c407a.svg";